import lodash from 'lodash'
import React, { createContext, useContext } from 'react'

const CustomerContext = createContext({
  customers: [],
  currentCustomer: undefined,
  changeCustomer: lodash.noop,
  theme: {},
  presets: [],
})

export const CustomerContextProvider = ({
  allowNoCustomer,
  currentCustomer,
  ...rest
}) => {
  if (!allowNoCustomer && !currentCustomer) {
    return null
  }
  return <CustomerContext.Provider value={{ currentCustomer }} {...rest} />
}

export default CustomerContext
